var exports = {
  "Aw": "listItem__LHoEzj",
  "zq": "ListItemDescriptionItem__xLZTh1",
  "Wc": "ListItemHeading__SWsVto",
  "og": "ReadOnlyListItemHeading__y9mA1a",
  "ao": "ListItemTitle__tvBEOE",
  "u6": "requiredBadgeEnabled__8Kvnbx",
  "tJ": "metadataContainer__afqpf1",
  "PU": "listItemMetadata__sIAxtr",
  "Ur": "ListItemDescription__cFmZdu",
  "cj": "definitionsListContainer__w9V1UZ",
  "ak": "propertiesCountText__3sZv2K",
  "gW": "managedByLabelContainer__S1WHDj",
};

module.exports = exports;
